import { useContext, useEffect } from "react";
import { Button, useTheme } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import TrackingUtil from "../../../utils/tracking";
import { NC_EVT } from "../../../constants/tracking";
import { useThemeStyles } from "../../../styles/themes";
import { formatTime } from "../../../utils/time";
import "./MaintenancePage.scss";
// import clevertapWebview from "../../../utils/clevertap";
// import { EVENT_NAME } from "../../../constants/clevertap";

const { REACT_APP_SUPPORT_EMAIL } = process.env;

// Experian displayType "SCREEN": onboarding blocked during scheduled partner downtime

const MaintenancePage = () => {
  const classes = useThemeStyles();
  const theme = useTheme();

  const { state, actions } = useContext(StoreContext);

  const startTime = formatTime({ time: state.experian?.startTime });
  const endTime = formatTime({ time: state.experian?.endTime });

  const content = {
    title: "Scheduled System Maintenance",
    message: [
      `To keep your experience safe, secure, and smooth, we perform scheduled system maintenance daily from ${startTime} to ${endTime}.`,
      "During this time, PayFlex applications will be temporarily unavailable. You may continue your application once the maintenance period has ended.",
      <>If you need any assistance, please contact our Support Team at <a href={`mailto:${REACT_APP_SUPPORT_EMAIL}`} style={{ color: theme.palette.primary.main, fontWeight: "bold" }}>{REACT_APP_SUPPORT_EMAIL}</a></>,
      "Thank you for your patience and understanding."
    ]
  };

  // const redirectDashboard = (type) => {
  //   if (type === "new") {
  //     actions.getDashboardUrl().then((res) => {
  //       if (res.data?.redirectionUrl) {
  //         window.location.href = res.data?.redirectionUrl;
  //       }
  //     });
  //     return;
  //   }

  //   if (state.dashboardUrl) {
  //     window.location.href = state.dashboardUrl;
  //   } else {
  //     window.location.href = process.env.REACT_APP_BNPL_DASHBOARD_URL;
  //   }
  // };

  useEffect(() => {
    TrackingUtil.sendNetcoreEventHelper(NC_EVT.OUTCOME_BNPL_MAINTENANCE, { source: "onboardingflow" });
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-maintenance ">
          <div
            className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <img
                className="banner"
                src="/images/maintenance@2x.png"
                alt="maintenance"
              />
              <p className="maintenance-title">
                {content.title}
              </p>
              {content.message.map((message) => (
                <p
                  className="maintenance-sub-title"
                  key={message}
                >
                  {message}
                </p>
              ))}
            </div>

            {/* <div className="action-holder" style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>

              {state.isOnboardingUpdate && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={() => redirectDashboard("new")}>
                  Done
                </Button>
              )}

            </div> */}

          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(MaintenancePage, {
  stepId: "MaintenancePage",
  endJourneyOnStepStart: true,
});
